export default {
    getTotalRevenue(amountArray) {
      let totalRevenue = 0.0;
      if (amountArray) {
        totalRevenue = amountArray.reduce((start, current) => start + current);
      }
      return totalRevenue;
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    getDailyTransactions(data, requiredDates) {
      //This function will return the daily transactions. this is because more than one transactions may exist in a day
  
      //fill all the data array with 0
      const dt = new Array(requiredDates.length + 1)
        .join("0")
        .split("")
        .map(parseFloat);
      for (let i = 0; i < data.length; i++) {
        let t = data[i];
        let text = this.getSpecialDate(new Date(t.date));
  
        //get the index where this date falls in the labels array
        let index = requiredDates.indexOf(text);
        if (index >= 0) {
          dt[index] = t.total;
        }
      }
      return { labels: requiredDates, data: dt };
    },
  
    getMonthText(month) {
      let monthText = [
        "Jan",
        "Feb",
        "March",
        "April",
        "May",
        "June",
        "July",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      if (month >= 0 || month <= 11) {
        return monthText[month];
      } else {
        return "None";
      }
    },
    getSpecialDate(date) {
      //Sep 3 2019
      return this.getMonthText(date.getMonth()) + " " + date.getDate();
    },
    formattedDate(date) {
      let month = date.getMonth() + 1, day = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if(day <10){
        day = "0"+day;
      }
      return date.getFullYear() + "-" + month + "-" + day;
    },
    getAllDates(start, end) {
      let startDate = new Date(start);
      let allDates = [];
      allDates.push(this.getSpecialDate(startDate));
      let meee = 1;
      //advance the start date
      let nextDay = this.getNextDay(startDate);
      while (nextDay != end) {
        meee++;
        if (meee == 100) break;
        allDates.push(this.getSpecialDate(new Date(nextDay)));
        startDate = new Date(nextDay);
        nextDay = this.getNextDay(startDate);
      }
      allDates.push(this.getSpecialDate(new Date(nextDay)));
  
      return allDates;
    },
    formattedDateText(date) {
      return (
        this.getMonthText(date.getMonth()) +
        " " +
        date.getDate() +
        " " +
        date.getFullYear()
      );
    },
  
    getPastDate(daysPast) {
      var today = new Date();
      var past = new Date();
      past.setDate(today.getDate() - daysPast);
      return this.formattedDate(past);
    },
    getNextDay(today) {
      //var today = new Date();
  
      today.setDate(today.getDate() + 1);
  
      return this.formattedDate(today);
    },
    getThirtyDaysAgo() {
      return this.getPastDate(30);
    },
    createChart(labels, data2) {
      var ctx = document.getElementById("bar").getContext("2d");
  
      var data = {
        labels,
        datasets: [
          {
            label: "iRecharge Revenue",
            backgroundColor: "rgba(54, 162, 235, 0.5)",
  
            borderColor: "rgba(54, 162, 235, 1)",
  
            borderWidth: 2,
            data: data2
          }
        ]
      };
      const functions = this;
      let chart = new Chart(ctx, {
        // The type of chart we want to create
        type: "bar",
  
        // The data for our dataset
        data: data,
  
        // Configuration options go here
        options: {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem) {
                return "NGN " + functions.formatNumber(tooltipItem.yLabel);
              }
            }
          } 
        }
      });
  
      return chart;
    }
  };
  